// extracted by mini-css-extract-plugin
export var avatar = "_ml-3";
export var avatarContainer = "_ml-2";
export var avatarSpacer = "_ml-5";
export var avatarSpacerContainer = "_ml-4";
export var avatarStackContainer = "_ml-1";
export var bubble = "_ml-0";
export var remainderBubble = "_ml-6";